export default "__VITE_ASSET__6XTP46a6__"